<template lang="pug">
  q-page.movement.q-pa-sm
    .row.gutter-md
      .col-12
        geometry-editor(:d="d", :r="r", :z="z", :d_eff="d_eff", :d_flat="d_flat", :ap="ap", :ae="ae", :vc="vc", :vf="vf", :fz="fz")
    .row.gutter-md
      .col-12
        q-card
          q-card-main
            .row.gutter-md
              .col-6
                q-field(label-width="2", helper="revolutions")
                  q-input(v-model="n", type="number" suffix="1/min")
                  div(slot="label", v-katex="'n'")
                q-field(label-width="2", helper="feed rate")
                  q-input(v-model="vf", type="number" suffix="mm/min")
                  div(slot="label", v-katex="'v_f'")
                q-field(label-width="2", helper="axial doc")
                  q-input(v-model="ap", type="number" suffix="mm")
                  div(slot="label", v-katex="'a_p'")
              .col-6
                q-field(label-width="2", helper="cutting speed")
                  q-input(v-model="vc", type="number" suffix="m/min")
                  div(slot="label", v-katex="'v_c'")
                q-field(label-width="2", helper="cutting speed")
                  q-input(v-model="vc_eff", type="number" suffix="m/min")
                  div(slot="label", v-katex="'v_{c, \\\\text{eff}}'")
                q-field(label-width="2", helper="feed per tooth")
                  q-input(v-model="fz", type="number" suffix="mm/tooth")
                  div(slot="label", v-katex="'f_z'")
                q-field(label-width="2", helper="feed per revolution")
                  q-input(v-model="fn", type="number" suffix="mm/rev")
                  div(slot="label", v-katex="'f_n'")
                q-field(label-width="2", helper="engagement frequency (per tooth)")
                  q-input(v-model="ft", type="number" suffix="Hz")
                  div(slot="label", v-katex="'f_t'")
</template>

<script>
import CuttingParameters from '@/lib/cutting-parameters.js';
import CuttingDataMixin from '@/mixins/cutting-data.js';
import GeometryEditor from '@/components/GeometryEditor.vue';

export default {
  name: 'speeds_feeds',
  components: {
    GeometryEditor
  },
  mixins: [CuttingDataMixin],
  data: function () {
    return {
    };
  },
  computed: {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
